<template lang="pug">
swiper(:options="swiperOpt")
  swiper-slide(v-for="item in data", :key="item.id")
    a(:href="item.origin_url", target="_blank")
      h3.swiper-title.px3.center {{ item.title }}
    .swiper-img
      img(:src="shift(item.o_pic_list[0])", :style="{width: '100%', height: '100%'}")
  .swiper-pagination(slot="pagination")
</template>

<script>
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../../node_modules/swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

import transformImgLink from '@/assets/utils/transformImgLink'
export default {
  props: ['data'],
  data () {
    return {
      swiperOpt: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        autoplay: 3000,
        // autoplayDisableOnInteraction: false,
        initialSlide: 1,
        paginationClickable: true,
        spaceBetween: 30,
        loop: true
      }
    }
  },
  methods: {
    shift (link) {
      return transformImgLink(link)
    }
  }
}
</script>

<style lang="stylus" scoped>
.swiper-container
  height 20vw
  max-height 380px
  .swiper-title
    position absolute
    top 0
    left 0
    padding 10px 20px 20px
    width 100%
    color white
    margin 0
    background linear-gradient(180deg, rgba(0, 0, 0, .9), rgba(0, 0, 0, .7) 50%, rgba(0, 0, 0, 0))
  .swiper-img
    height 100%
    width 100%
    background-size 100% 100%
</style>
<style lang="stylus">
.swiper-container
  .swiper-pagination-bullet
    background-color #fff
</style>





// WEBPACK FOOTER //
// Swiper.vue?325963df